import { EnumAddressRole, EnumServiceType } from '@Model';
import { withCondition } from '@Hooks/useListApi';
import { EnumFilterExpressionOperation, EnumOperation, type ListRequest } from '@synqo/frontend-component-library';

/** The request narrowed to the services that name a material. */
// @ai-generated 2026-10-02T11:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const onlyMaterials = (listRequest: ListRequest): ListRequest =>
    withCondition(listRequest, {
        field: 'type',
        value: EnumServiceType.Material.toString(),
        operator: EnumOperation.Equal,
    });

/** The request narrowed to the addresses that can be a customer, which are the debtors and creditors. */
// @ai-generated 2026-10-02T11:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const onlyCustomers = (listRequest: ListRequest): ListRequest =>
    withCondition(listRequest, {
        operation: EnumFilterExpressionOperation.Or,
        filters: [EnumAddressRole.Debtor, EnumAddressRole.Creditor].map((role) => ({
            field: 'roles',
            value: role.toString(),
            operator: EnumOperation.Includes,
        })),
    });

/** The request narrowed to the container types that are managed collectively. */
// @ai-generated 2026-10-02T11:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const onlyCollectiveTypes = (listRequest: ListRequest): ListRequest =>
    withCondition(listRequest, {
        field: 'uses_individual_management',
        value: 'false',
        operator: EnumOperation.Equal,
    });

/** The request narrowed to the container types that are managed individually. */
// @ai-generated 2026-10-02T12:10:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const onlyIndividualTypes = (listRequest: ListRequest): ListRequest =>
    withCondition(listRequest, {
        field: 'uses_individual_management',
        value: 'true',
        operator: EnumOperation.Equal,
    });

/** The request narrowed to the containers of one container type. */
// @ai-generated 2026-10-02T12:10:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export const onlyContainersOfType = (listRequest: ListRequest, containerTypeId: string): ListRequest =>
    withCondition(listRequest, {
        field: 'type.foreign_key',
        value: containerTypeId,
        operator: EnumOperation.Equal,
    });
